import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "struct6";
const idNext = "struct7";
const idPrev = "struct5";

const next = `
global parameters:
  - parameter: character
    parameters:
      - parameter: weapon
        choices:
          - choice: dagger
          - choice: ranged
            choices:
              - choice: bow
              - choice: crossbow
          - choice: melee
            choices:
              - choice: axe
              - choice: mace
              - choice: sword
      - parameter: name
        choices:
          - choice: hero
            choices:
              - choice: Peter
              - choice: Susan
              - choice: Edmund
              - choice: Lucy
          - choice: foe
            choices:
              - choice: witch
              - choice: cyclops
              - choice: giant
    logic:
      - constraint: Girls use daggers
        expression: "'name' IN ['hero::Susan', 'hero::Lucy'] => 'weapon' IS 'dagger'"
functions:
  - function: simple
    parameters:
      - linked parameter: hero
        linked to: character
      - linked parameter: foe
        linked to: character
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

const prev = `
global parameters:
  - parameter: character
    parameters:
      - parameter: weapon
        choices:
          - choice: dagger
          - choice: ranged
            choices:
              - choice: bow
              - choice: crossbow
          - choice: melee
            choices:
              - choice: axe
              - choice: mace
              - choice: sword
      - parameter: name
        choices:
          - choice: hero
            choices:
              - choice: Peter
              - choice: Susan
              - choice: Edmund
              - choice: Lucy
          - choice: foe
            choices:
              - choice: witch
              - choice: cyclops
              - choice: giant
functions:
  - function: simple
    parameters:
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: mountain
          - choice: river
          - choice: lake
`;

function ManualStructures6({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_globals") &&
        !document.getElementById("add_global_parameter") && (
          <div className={`${styles["container"]} ${styles["container-st6"]} ${styles["overlay"]}`}>
            <div id="tutorial-text-st6" className={`${styles["container__text"]}`}>
              <p>To show/hide global parameters click on the header.</p>
            </div>

            <Xarrow
              key={`arrow-1-${renderTrigger}`}
              start="tutorial-text-st6"
              end="header_globals"
              color="#415B32"
              strokeWidth={2}
              path="smooth"
              curveness={0.8}
              headSize={6}
            />
          </div>
        )}

      <div className={`${styles["foreground"]} ${styles["foreground-st5"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Now, let's create two linked parameters, namely <b>hero</b> and <b>foe</b>. To do it,
              drag and drop the <b>character</b> parameter to the function panel. Make it twice,
              once for each parameter.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateStructures6 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resCharacter, msg: msgCharacter } = tutorialUtils.validateParameters(
      root,
      "root→[function]→simple",
      ["hero", "foe", "location"],
    );

    if (!resCharacter) {
      setMessage(msgCharacter);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualStructures6;
